<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
   <sequential-entrance fromTop>

    <v-row>
      <v-col
        sm="12"
        md="3"
      >
      <v-row>
      <v-btn
      @click="addcommand(1)"
      >
        add $1.00
      </v-btn>
      <v-btn
      @click="addcommand(5)"
      >
        add $5.00
      </v-btn>
      <v-btn
      @click="addcommand(10)"
      >
        add $10.00
      </v-btn>
      <v-btn
      @click="addcommand(20)"
      >
        add $20.00
      </v-btn>
      <v-btn
      @click="addcommand(50)"
      >
        add $50.00
      </v-btn>
      <v-btn
      @click="addcommand(100)"
      >
        add $100.00
      </v-btn>  
      </v-row>
          

      </v-col>
      <v-row>
      <v-col
        sm="12"
        md="3"
      >
      <v-btn
      @click="runcashheld"
      >
        Cash Held
      </v-btn> 
      <v-btn
      @click="runcit"
      >
        Do CIT/Stacker Pull
      </v-btn>
      <v-btn
      @click="runreject"
      >
        Do Note Reject
      </v-btn>
      <v-btn
      @click="runjam"
      >
        Do Note Jam
      </v-btn>      
      <v-btn
      @click="runsplit"
      >
        Do split
      </v-btn>  
      <v-btn
      @click="rundeposit"
      >
        Do User Deposit
      </v-btn>
      <v-text-field
            v-model="manualamount"
            append-icon="mdi-cash"
            label="Amount"
            single-line
      ></v-text-field>
      <v-btn
      @click="runmanualdeposit"
      >
        Do Manual Drop
      </v-btn>       
      </v-col> 
      </v-row>
    </v-row>
    </sequential-entrance>
  </v-container>
</template>
<script>

  var numeral = require('numeral')

  export default {
    name: 'Wallets2',

    data () {
      return {
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        icons: true,
        manualamount: 0,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        tab: null,
        tabs3: [
          {
            text: 'Locations',
            icon: 'mdi-map-marker'
          },
          {
            text: 'Wallets',
            icon: 'mdi-wallet-travel'
          },
          {
            text: 'Instant',
            icon: ' mdi-swap-horizontal'
          }
        ],
        tabs: 0,
        list: {
          0: false,
          1: false,
          2: false
        }
      }
    },
    computed: {
      currentwallets () {
        //this.$store.dispatch('loadCurrentUserProfile')
        let ourwallets = this.$store.getters.currentuserwallets
        return ourwallets
      },
      currentLocations () {
        return this.$store.getters.loadedSites
      },      
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      }
    },
    created () {
      this.$store.dispatch('loadCurrentUserProfile')
    },
    methods: {
      complete (index) {
        this.list[index] = !this.list[index]
      },
      addcommand (amount) {
        this.$store.dispatch('addcommand', amount)
      },
      runcit () {
        this.$store.dispatch('simcit')
      },
      runjam () {
        this.$store.dispatch('simjam')
      },      
      runreject () {
        this.$store.dispatch('simreject')
      },
      runsplit() {
        this.$store.dispatch('simsplit')
      },
      rundeposit() {
        this.$store.dispatch('simuserdep')        
      },
      runmanualdeposit() {
        // convert to pennies
        let pennies = numeral(this.manualamount) 
        let val = pennies.value() * 100
        this.$store.dispatch('simmanualdep', val)        
      },
      cloneeod() {
        this.$store.dispatch('cloneeod')
      },
      runcashheld() {
        this.$store.dispatch('simcashheld')
      }
    }
  }
</script>
